

import { useEffect } from 'react'
import Select from 'react-select'
import { ParamaterDDLAPI, TimeDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const TimeDDL = (props) => {
    const { TimeID, setTimeID } = props

    const userDetails = useAuthState();
    const { UserID, token } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = { 
            M_UserID: UserID,
            token: token
        }
        dispatch(TimeDDLAPI({ data }))
    }, [])

    const { TimeData } = useSelector(state => state.TimeDDLData)

    useEffect(() => {
        handleWorkAssignByDDL()
    }, [TimeData])

    const handleWorkAssignByDDL = () => {
        // console.log(DeptDDLDataa)
        if (TimeData && TimeData.table && TimeData.table.length > 0) {
            let list = TimeData.table.map((item, index) => ({
                value: item.m_wS_TimeID,
                label: item.timeValue,
            }))

            setTimeID({
                DDL: list,
                ID: 0,
                Label: "Select..."
            })
        }
        else {
            setTimeID({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <Select
                isClearable
                isSearchable
                maxMenuHeight={150}
                value={{ value: TimeID.ID, label: TimeID.Label }}
                onChange={(e) => {
                    e ?
                        setTimeID({ ...TimeID, ID: e.value, Label: e.label })
                        :
                        setTimeID({ ...TimeID, ID: 0, Label: "Select..." })

                }}
                options={TimeID.DDL}
            />
        </div>
    )
}